export const LOG_IN = 'LOG_IN';
export const LOG_OUT = 'LOG_OUT'

export function setAuthedUser (userInfo) {
  return {
    type: LOG_IN,
    name: userInfo.name,
    id: userInfo.id
  }
}

export function logOut () {
  return {
    type: LOG_OUT,
    name: '',
    id: ''
  }
}